// extracted by mini-css-extract-plugin
module.exports = {"button":"button__1MWCR","gray":"gray__3lc9h"};